// Stub — wired in Phase 5 (output paste + analysis).

import { Inbox } from 'lucide-react';
import type { PastedOutputPayload } from '@/lib/workflowStreamProtocol';

interface PastedOutputBlockProps {
  output: PastedOutputPayload;
}

export function PastedOutputBlock({ output }: PastedOutputBlockProps) {
  return (
    <div className="rounded-xl border border-border bg-muted/30 overflow-hidden">
      <div className="flex items-center gap-2 px-3 py-2 border-b border-border text-xs">
        <Inbox className="h-3.5 w-3.5" />
        <span className="font-medium">pasted output</span>
        {output.meta?.rows ? <span className="text-muted-foreground">· {output.meta.rows} rows</span> : null}
      </div>
      <pre className="p-3 text-xs font-mono whitespace-pre-wrap max-h-48 overflow-auto text-muted-foreground">{output.text.slice(0, 1000)}{output.text.length > 1000 ? '\n…' : ''}</pre>
    </div>
  );
}
